export default (state = false, action) => {
  switch (action.type) {
    case 'TABLET_DETERMINE':
      return window.innerWidth >= 768;
    default:
      return state;
  }
};
